import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import {ApiService, CustomHttpParams} from 'src/app/services/api.service';
import {extractErrorMessage} from "../../../common/common";
import {VenViewModel} from "../../../model/vens.model";
import {LoaderComponent} from "../../common/loader/loader.component";

@Component({
  selector: "app-request-event",
  standalone: true,
  imports: [RouterModule, CommonModule, FormsModule, LoaderComponent],
  templateUrl: "./request-event.component.html",
  styleUrl: "./request-event.component.scss",
})
export class RequestEventComponent implements OnInit {
  protected isLoading: boolean = false;
  protected vens: Partial<VenViewModel>[] = [];
  protected id: number | null;
  protected result: string = "";
  protected error: string | null = null;

  constructor(
    private requestEventService: ApiService
  ) {}

  ngOnInit(): void {
    this.isLoading = true;
    const queryParams: CustomHttpParams = {
      'depths': JSON.stringify({
        "registration": 1,
        "vtn": 1,
        "cert": 1,
      }),
      'columns': { "ven": ["id", "name", "cert", "vtn", "paused", "profile", "registration"] }
    };
    this.requestEventService.findVens(queryParams).subscribe({
      next: (response: Partial<VenViewModel>[]) => {
        this.vens = response.filter((ven: Partial<VenViewModel>) =>
          {
            const condition1 = ven.cert !== null && ven.vtn !== null; // VENs that have cert-index and are associated with a VTN
            const condition2 = ven.profile === '2.0a' || (ven.profile === '2.0b' && ven.registration !== null); // 2.0b VENs must have registration-index
            return condition1 && condition2;
          });
        this.isLoading = false;
      },
      error: (err: any) => {
        console.error(err);
        this.error = extractErrorMessage(err, "Failed to load VENs.");
        this.isLoading = false;
      }
    });
  }

  getVen(event: any) {
    this.id = Number(event.value);
  }

  performAction() {
    if (!this.id) {
      this.error = "Please select a VEN.";
      return;
    }

    this.error = null;
    this.result = "";
    this.isLoading = true;
    this.requestEventService
      .requestEvent(this.id)
      .subscribe({
        next: (_) => {
          this.result = "Successfully sent request event.";
          this.isLoading = false;
        },
        error: (err) => {
          console.error(err);
          this.error = extractErrorMessage(err);
          this.isLoading = false;
        }
      });
  }
}
